import { render, staticRenderFns } from "./templateModal.vue?vue&type=template&id=1b7d6c12&"
import script from "./templateModal.vue?vue&type=script&lang=js&"
export * from "./templateModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports